
export default (projects, type = '') => {
  return projects.filter(project => project.type === type);
};


// WEBPACK FOOTER //
// ./src/selectors/projects.js